import { Row, Col } from "antd";
import React from "react";

import Tool from "./Tool";

//COMPUTER
import caseComputer from "../../images/tools/case.jpg";
import waterCooling from "../../images/tools/watercooling.jpg";
import motherboard from "../../images/tools/motherboard.jpg";
import graphic from "../../images/tools/graphic.jpg";
import ram from "../../images/tools/ram.jpg";
import cpu from "../../images/tools/cpu.jpg";
import sdd from "../../images/tools/sdd.jpg";
import hdd from "../../images/tools/hdd.jpg";

const Computer = props => {
  return (
    <React.Fragment>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Case Thermaltake P3"
            description="Snow Edition"
            link="http://www.thermaltake.com/Chassis/Open_Frame_/Core/C_00002914/Core_P3_Snow_Edition/design.htm"
            image={caseComputer}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="GPU GTX 1080"
            description="MSI Armor 8G Oc"
            link="https://www.msi.com/Graphics-card/GeForce-GTX-1080-ARMOR-8G.html"
            image={graphic}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Water 3.0"
            description="Riing RGB 360"
            link="http://www.thermaltake.com/products-model.aspx?id=C_00002775"
            image={waterCooling}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Motherboard MSI Z270"
            description="Tomahawk Arctic"
            link="https://www.msi.com/Motherboard/Z270-TOMAHAWK-ARCTIC.html"
            image={motherboard}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="CPU i7"
            description="7700K (4,2 GHz)"
            link="https://ark.intel.com/products/97129/Intel-Core-i7-7700K-Processor-8M-Cache-up-to-4_50-GHz"
            image={cpu}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Ram 16 Go"
            description="Ballistix® Tactical DDR4"
            link="https://ballistixgaming.com/products/dram/tactical/tactical-DDR4.html"
            image={ram}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="HDD WD Black"
            description="3,5 - 2 To"
            link="https://www.wdc.com/products/internal-storage/wd-black-desktop.html"
            image={hdd}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="SDD Samsung"
            description="Evo 850 500g"
            link="https://www.samsung.com/semiconductor/minisite/ssd/product/consumer/850evo/"
            image={sdd}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Computer;



// WEBPACK FOOTER //
// ./src/components/Tools/Computer.js